import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './resources.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className="resource-child">
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/resource' className="mianbaoxie">流量资源</a>  <i className='glyphicon glyphicon-toright'></i> <span>视频广告</span>
				</div>
				<div className='common-title minWith' style={{marginBottom: '24px'}}>什么是视频广告？</div>
				<div className='text-center minWith'>视频广告是指在移动设备内进行的插播视频的模式。分为传统贴片广告和In-App视频广告。</div>
				<div className='text-title text-center minWith'>您的广告可以展示在这里</div>
				<div className='home-contain' style={{paddingBottom: '50px', marginTop: '40px'}} >
					<div className='home-contain text-contain' style={{paddingBottom: '50px'}}>
						<div className='text-center' >
							<div className="advDemo" style={{marginRight: '152px'}}>
								<span className='second-title' style={{margin: '0 0 20px 0'}}>频道信息流</span>
								<img style={{display: 'inline-block'}} src={`${process.env.PUBLIC_URL}/images/sp1.png`} />
								<img style={{display: 'inline-block', marginLeft: '50px'}} src={`${process.env.PUBLIC_URL}/images/sp2.png`} />
							</div>
							<div className="advDemo">
								<span className='second-title' style={{margin: '0 0 20px 0'}}>视频信息流</span>
								<img style={{display: 'inline-block'}} src={`${process.env.PUBLIC_URL}/images/sp3.png`} />
								<img style={{display: 'inline-block', marginLeft: '50px'}} src={`${process.env.PUBLIC_URL}/images/sp4.png`} />
							</div>
						</div>
                        <div className='text-center'>
						<div className="advDemo" style={{marginRight:'82px'}}>
							<span className='second-title' style={{margin: '40px 0 20px 0'}}>暂停广告</span>
								<img style={{display: 'inline-block'}} src={`${process.env.PUBLIC_URL}/images/sp5.png`} />
						</div>
							<div className="advDemo">
								<span className='second-title' style={{margin: '40px 0 20px 0'}}>视频浮层</span>
								<img style={{display: 'inline-block'}} src={`${process.env.PUBLIC_URL}/images/sp6.png`} />
							</div>
						</div>

					</div>
				</div>
			</div></div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/resources/spbanner.jsx